import { generateKeyBetween } from 'fractional-indexing';
import { sortByIndex } from '../render/utils/node';
import { LAYER_ORDER_TYPES, TYPES } from '../render/constants';
import { Action } from './action';

export const createLayerHandler = (type) => (stageContext) => {
  const selectedNodes = stageContext.api.getSelectedNodes();
  if (!selectedNodes.length) return;
  const node = selectedNodes[0];
  const id = node.id;
  reorderNode(stageContext, id, type);
};

function condition(context) {
  return context.api.getSelectedNodes().length > 0;
}

export const forwardAction = new Action({
  name: 'Forward',
  handler: createLayerHandler(LAYER_ORDER_TYPES.forward),
  shortcuts: ']',
  condition: condition,
  icon: 'arrow-up',
});

export const backwardAction = new Action({
  name: 'Backward',
  handler: createLayerHandler(LAYER_ORDER_TYPES.backward),
  shortcuts: '[',
  condition: condition,
  icon: 'arrow-down',
});

export const bringToFrontAction = new Action({
  name: 'BringToFront',
  handler: createLayerHandler(LAYER_ORDER_TYPES.bringToFront),
  shortcuts: 'Shift+}',
  condition: condition,
  icon: 'arrow-up',
});

export const sendToBackAction = new Action({
  name: 'SendToBack',
  handler: createLayerHandler(LAYER_ORDER_TYPES.bringToBack),
  shortcuts: 'Shift+{',
  condition: condition,
  icon: 'arrow-down',
});

export function reorderNode(stageContext, id, type) {
  const node = stageContext.api.getNode(id);
  if (!node) return console.warn('node missing with id', id);
  const nodes = stageContext.api.getNodes();
  const siblings = nodes
    .filter((n) => (node.parentId ? n.parentId === node.parentId : !node.parentId && !n.parentId))
    .sort(sortByIndex);

  const index = siblings.findIndex((n) => n.id === id);
  if (index === -1) return console.warn('siblings missing with id', siblings, node);
  let newIndex = node.index;

  switch (type) {
    case LAYER_ORDER_TYPES.bringToFront: {
      if (index === siblings.length - 1) return;
      const lastNode = siblings[siblings.length - 1];
      newIndex = generateKeyBetween(lastNode.index, null);
      break;
    }
    case LAYER_ORDER_TYPES.forward: {
      if (index === siblings.length - 1) return;
      const nextNode = siblings[index + 1];
      newIndex = generateKeyBetween(nextNode.index, null);
      break;
    }
    case LAYER_ORDER_TYPES.bringToBack: {
      if (index === 0) return;
      const firstNode = siblings[0];
      newIndex = generateKeyBetween(null, firstNode.index);
      break;
    }
    case LAYER_ORDER_TYPES.backward: {
      if (index === 0) return;
      const prevNode = siblings[index - 1];
      newIndex = generateKeyBetween(null, prevNode.index);
      break;
    }
  }
  if (newIndex === node.index) return;
  stageContext.api.updateNode(node.id, {
    index: newIndex,
  });
  if (node.type === TYPES.frame) {
    stageContext.api.layoutFrame();
  }
}
